document.addEventListener("DOMContentLoaded", function () {
    var productGrids = document.querySelectorAll(".grid.product-grid");

    productGrids.forEach(function (productGrid) {
        var sectionId = productGrid.getAttribute("data-section-id");
        var variantDataMap = window["variantDataMap" + sectionId.replace(/-/g, "_")];

        productGrid.addEventListener("change", function (e) {
            if (
                e.target.matches(
                    'input[type="radio"][data-section-id="' + sectionId + '"]'
                )
            ) {
                var card = e.target.closest(
                    `.card-product-custom-div[data-section-id="${sectionId}"]`
                );

                var variantId = e.target.getAttribute("data-variant-id");
                var variantData = variantDataMap[variantId];

                if (!variantData) {
                    return;
                }

                // Update the product image with lazy loading logic
                var productImageElement = card.querySelector(".c-card-product__media img");
                var productRolloverImageElement = card.querySelector(".c-card-product__media img.rollover-image");
                var rolloverImageSrc = e.target.getAttribute('data-rollover-image-url');
                if (productImageElement) {
                    var lazyLoadAllVariants =
                        card.getAttribute("data-lazy-load-all-variants") === "true";
                    if (lazyLoadAllVariants) {
                        var preloadedImage = card.querySelector(
                            `img[data-variant-id="${variantId}"]`
                        );
                        if (preloadedImage) {
                            productImageElement.src = preloadedImage.src;
                            productImageElement.srcset = preloadedImage.srcset;
                        }
                    } else {
                        // Update src and srcset for responsive images
                        var dynamicSrcset = [
                            variantData.imageUrl + "?width=165 165w",
                            variantData.imageUrl + "?width=360 360w",
                            variantData.imageUrl + "?width=533 533w",
                            variantData.imageUrl + "?width=720 720w",
                            variantData.imageUrl + "?width=940 940w",
                            variantData.imageUrl + "?width=1066 1066w",
                        ].join(", ");
                        productImageElement.srcset = dynamicSrcset;
                        productImageElement.src = variantData.imageUrl;
                        if(rolloverImageSrc) {
                            var rolloverSrcset = [
                                rolloverImageSrc + "?width=165 165w",
                            ].join(", ");
                            productRolloverImageElement.srcset = rolloverSrcset;
                            productRolloverImageElement.src = rolloverImageSrc;
                            productRolloverImageElement.style.display = "block";
                        }
                        else {
                            productRolloverImageElement.srcset = "";
                            productRolloverImageElement.src = "";
                            productRolloverImageElement.style.display = "none";

                        }
                    }
                }

                var productLinks = card.querySelectorAll(
                    'a[class^="c-card-product__link"], .c-card-product__action a[class^="c-btn"]'
                );
                productLinks.forEach(function (link) {
                    link.href = variantData.productUrl;
                });
            }
        });
    });
});
